const defaultTimePipe = (sec) => { 
    const minutes = ( sec >= 60 ? Math.round(sec/60) : 0); 
	return minutes ? (minutes + ' мин') : (sec + ' сек'); 
}
 
export default defaultTimePipe;